import useCdnConfigContext from "../context/useCdnConfigContext.js";
import { getCroppedImageUrl } from "../utils/getCroppedImageUrl.js";
import switchDomain from "../utils/switchDomain-v2.js";
import "react";
import "../context/CdnConfigContext.js";
import "url-parse";
import "../constants/constants.js";
import "../utils/tools.js";
import "../utils/getDevicePixelRatio.js";
import "../constants/imageStandards.js";
function useCroppedImage() {
  const { cdnSwitchMap } = useCdnConfigContext();
  const getSwitchedUrl = (url) => {
    const switchResult = switchDomain(url, cdnSwitchMap);
    return switchResult;
  };
  const getCroppedUrl = (url, configs) => {
    const switchResult = getSwitchedUrl(url);
    if (!switchResult || typeof switchResult !== "string")
      return switchResult;
    const finalUrl = getCroppedImageUrl(switchResult, configs || {});
    return finalUrl;
  };
  return {
    getCroppedUrl,
    getSwitchedUrl
  };
}
export {
  useCroppedImage as default
};
//# sourceMappingURL=useCroppedImage.js.map
